import { productInfoPopup } from '../components/popups/ProductInfoPopup';
export async function popProductInfo() {
    try {
        await productInfoPopup.pop();
    }
    catch { }
}
